import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SelectedWork from './components/SelectedWork';
import WhatIMake from './components/WhatIMake';
import WhoIAm from './components/WhoIAm';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import PlaybookSection from './components/PlaybookSection';
import WorkWithMe from './pages/WorkWithMe';
import AIForCreatives from './pages/AIForCreatives';
import AIToolsForCreatives from './pages/AIToolsForCreatives';
import AIToolsCheckout from './pages/AIToolsCheckout';
import AIToolsSuccess from './pages/AIToolsSuccess';
import CheckoutPage from './pages/CheckoutPage';
import SuccessPage from './pages/SuccessPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import './App.css';

// Home Page Component
const HomePage = () => {
  return (
    <>
      <HeroSection />
      <PlaybookSection />
      <SelectedWork />
      <WhatIMake />
      <WhoIAm />
      <ContactSection />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#0B0D10]">
          <Routes>
            {/* Main site with header/footer */}
            <Route path="/" element={
              <>
                <Header />
                <main><HomePage /></main>
                <Footer />
              </>
            } />
            <Route path="/work-with-me" element={
              <>
                <Header />
                <main><WorkWithMe /></main>
                <Footer />
              </>
            } />
            
            {/* Quiz funnel - standalone pages without main site header/footer */}
            <Route path="/ai-for-creatives" element={<AIForCreatives />} />
            <Route path="/ai-for-creatives/checkout/:productId" element={<CheckoutPage />} />
            <Route path="/ai-for-creatives/success/:productId" element={<SuccessPage />} />
            
            {/* AI Tools Course - standalone landing page */}
            <Route path="/ai-tools-for-creatives" element={<AIToolsForCreatives />} />
            <Route path="/ai-tools-for-creatives/checkout/:productId" element={<AIToolsCheckout />} />
            <Route path="/ai-tools-for-creatives/success/:productId" element={<AIToolsSuccess />} />

            {/* Legal pages */}
            <Route path="/privacypolicy" element={
              <>
                <Header />
                <main><PrivacyPolicy /></main>
                <Footer />
              </>
            } />
            <Route path="/termsofservice" element={
              <>
                <Header />
                <main><TermsOfService /></main>
                <Footer />
              </>
            } />
          </Routes>
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
